{
  "process_creation": {
    "primary_fields": [
      "parent_process_path",
      "parent_process_id",
      "process_path",
      "process_id",
      "process_cmdline"
    ],
    "secondary_fields": [
      "parent_process_cmdline",
      "username",
      "hostname",
      "process_name",
      "parent_process_name"
    ]
  },
  "registry_event": {
    "primary_fields": [
      "registry_path",
      "registry_key_name",
      "registry_value_name",
      "process_path"
    ],
    "secondary_fields": ["hostname", "process_id"]
  },
  "file_event": {
    "primary_fields": ["target_path"],
    "secondary_fields": ["process_path", "process_cmdline"]
  },
  "dns": {
    "primary_fields": ["dns_query"],
    "secondary_fields": [
      "protocol",
      "dns_answer",
      "src_ip",
      "dest_ip",
      "dest_port"
    ]
  },
  "network_connection": {
    "primary_fields": ["dest_ip", "src_ip", "dest_port"],
    "secondary_fields": [
      "url",
      "service",
      "protocol",
      "user_agent",
      "referrer",
      "process_path"
    ]
  },
  "pipe_created": {
    "primary_fields": ["pipe_name", "hostname", "process_path"],
    "secondary_fields": ["process_id", "object_name"]
  },
  "security": {
    "primary_fields": ["hostname", "message"],
    "secondary_fields": [
      "task_category",
      "service_file_path",
      "service_name",
      "target_path",
      "event_id",
      "username",
      "object_name"
    ]
  },
  "system": {
    "primary_fields": ["hostname", "message"],
    "secondary_fields": ["event_id", "username"]
  },
  "webserver": {
    "primary_fields": ["dest_ip", "src_ip", "domain", "url"],
    "secondary_fields": ["dest_port", "message"]
  },
  "application": {
    "primary_fields": ["hostname", "message"],
    "secondary_fields": ["event_id", "username"]
  },
  "cloud": {
    "primary_fields": ["user_agent", "message"],
    "secondary_fields": ["hostname"]
  },
  "authentication_events": {
    "primary_fields": ["username", "hostname", "action"],
    "secondary_fields": ["event_id", "process_path", "access", "event_type"]
  },
  "image_load": {
    "primary_fields": ["process_path", "object_loaded", "hostname"],
    "secondary_fields": ["process_id", "message", "username"]
  }
}
